import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useCandidateDrawer } from "@/components/CandidateDrawer";
import { refsPillClass, initials } from "@/lib/cc";
import { FileCheck2 } from "lucide-react";

export default function ReferencesPage() {
  const [cands, setCands] = useState([]);
  const { open } = useCandidateDrawer();

  useEffect(() => {
    api.get("/candidates").then(({ data }) => setCands(data));
  }, []);

  const summary = cands.reduce((acc, c) => {
    (c.references || []).forEach((r) => {
      acc[r.status] = (acc[r.status] || 0) + 1;
    });
    return acc;
  }, {});

  return (
    <div className="fade-up">
      <div className="mb-6">
        <div className="label-eyebrow mb-2">Compliance</div>
        <h1 className="font-display text-4xl font-bold flex items-center gap-3"><FileCheck2 className="w-8 h-8" />References</h1>
        <p className="text-[var(--cc-text-soft)] mt-1">3 references required per candidate per CQC safer recruitment standards.</p>
      </div>

      <div className="grid grid-cols-4 gap-3 mb-6">
        {[{ k: "awaiting", l: "Awaiting" }, { k: "received", l: "Received" }, { k: "verified", l: "Verified" }, { k: "flagged", l: "Flagged" }].map((g) => (
          <div key={g.k} className="cc-card p-4">
            <div className="label-eyebrow mb-2">{g.l}</div>
            <div className="font-dash text-3xl font-bold">{summary[g.k] || 0}</div>
          </div>
        ))}
      </div>

      <div className="space-y-3">
        {cands.map((c) => {
          const refs = c.references || [];
          const done = refs.filter((r) => r.status === "verified" || r.status === "received").length;
          const pct = refs.length ? Math.round((done / refs.length) * 100) : 0;
          return (
            <div key={c.id} className="cc-card p-5 cursor-pointer cc-card-hover" onClick={() => open(c.id)} data-testid={`ref-row-${c.id}`}>
              <div className="flex items-center justify-between gap-6">
                <div className="flex items-center gap-3 min-w-0 flex-1">
                  <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
                       style={{ background: "var(--cc-primary)" }}>{initials(c.first_name, c.last_name)}</div>
                  <div className="min-w-0">
                    <div className="font-semibold truncate">{c.first_name} {c.last_name}</div>
                    <div className="text-xs text-[var(--cc-text-soft)] truncate">{c.job_title}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {refs.map((r, i) => (
                    <span key={i} className={`pill ${refsPillClass(r.status)} !text-[10px]`}>{r.status}</span>
                  ))}
                </div>
                <div className="w-40">
                  <div className="text-xs text-[var(--cc-text-soft)] mb-1">{done}/{refs.length} · {pct}%</div>
                  <div className="cc-progress"><div className="cc-progress-fill" style={{ width: `${pct}%` }} /></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
